export interface StreamingPlan {
  id: string;
  name: string;
  tagline: string;
  price: string;
  priceLabel: string;
  description: string;
  benefits: { icon: string; label: string; desc: string }[];
  highlighted: boolean;
  badge: string;
  cta: string;
  comingSoon: boolean;
}

export const streamingPlans: StreamingPlan[] = [
  {
    id: 'own-streaming',
    name: 'Ya tengo Streaming',
    tagline: 'Conectá tu proveedor actual',
    price: 'Sin costo extra',
    priceLabel: 'Solo pagás tu proveedor externo',
    description: 'Si ya tenés tu propio servidor de streaming, conectalo a RFW con tu Stream URL. Nosotros consumimos tu señal y la distribuimos dentro de la plataforma.',
    benefits: [
      { icon: 'ri-link', label: 'Stream URL', desc: 'Conectá tu URL actual sin cambiar de proveedor.' },
      { icon: 'ri-sound-module-line', label: 'Formatos compatibles', desc: 'MP3, AAC, OGG y más. Detectamos tu formato automáticamente.' },
      { icon: 'ri-signal-wifi-line', label: 'Estado de señal', desc: 'Monitoreá si tu stream está online, offline o con problemas.' },
      { icon: 'ri-radar-line', label: 'Probar señal', desc: 'Verificá la conexión y diagnosticá tu transmisión en segundos.' },
    ],
    highlighted: false,
    badge: 'Streaming externo',
    cta: 'Conectar mi Stream URL',
    comingSoon: false,
  },
  {
    id: 'rfw-hosting',
    name: 'Streaming con RFW',
    tagline: 'Hosting de streaming administrado por RFW',
    price: 'Próximamente',
    priceLabel: 'Precio a definir',
    description: 'No tenés servidor de streaming. RFW te proporciona una cuenta completa con AutoDJ, SSL, estadísticas y soporte. Todo integrado sin salir de la plataforma.',
    benefits: [
      { icon: 'ri-disc-line', label: 'AutoDJ', desc: 'Programación automática 24/7 sin depender de una PC encendida.' },
      { icon: 'ri-shield-keyhole-line', label: 'SSL', desc: 'Streaming seguro con certificado SSL incluido en tu URL.' },
      { icon: 'ri-bar-chart-grouped-line', label: 'Estadísticas', desc: 'Oyentes simultáneos, geolocalización, horarios pico y más.' },
      { icon: 'ri-play-circle-line', label: 'Web Player', desc: 'Reproductor web embebido listo para usar en tu página de RFW.' },
      { icon: 'ri-customer-service-2-line', label: 'Soporte', desc: 'Asistencia técnica para tu streaming desde el equipo RFW.' },
      { icon: 'ri-settings-3-line', label: 'Configuración inicial', desc: 'Nosotros configuramos todo. Vos solo transmitís.' },
    ],
    highlighted: true,
    badge: 'RFW Hosting',
    cta: 'Me interesa',
    comingSoon: true,
  },
];

export const streamFormats: string[] = [
  'MP3',
  'AAC',
  'OGG / Vorbis',
  'FLAC',
  'Opus',
  'WMA',
];

export const streamStatusOptions: { value: string; label: string; dot: string; text: string }[] = [
  { value: 'online', label: 'Online', dot: 'bg-emerald-500', text: 'text-emerald-600' },
  { value: 'offline', label: 'Offline', dot: 'bg-amber-500', text: 'text-amber-600' },
  { value: 'pending', label: 'Pendiente', dot: 'bg-sky-500', text: 'text-sky-600' },
  { value: 'fallback', label: 'RFW Radio (respaldo)', dot: 'bg-foreground-400', text: 'text-foreground-500' },
];